import script from "./version.vue?vue&type=script&setup=true&lang=ts"
export * from "./version.vue?vue&type=script&setup=true&lang=ts"

import "./version.vue?vue&type=style&index=0&id=5994139c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5994139c"]])

export default __exports__